// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"f097233e","238":"7b8150dd","686":"b79dfa2f"}[chunkId] + ".chunk.js";
};